import React from 'react';
import { useSelector } from 'react-redux';
import FileCardSkeleton from './FileCardSkeleton';
import { RootState } from '../../../../../reducers';

const FilesSkeleton: React.FC = () => {
  const { library } = useSelector((state: RootState) => state);
  const { status } = library.files;
  if (status !== 'pending') {
    return null;
  }
  return (
    <>
      {[...Array(20)].map((_, index) => (
        <div
          key={index}
          className="col-span-1"
          data-testid="file-card-skeleton"
        >
          <FileCardSkeleton />
        </div>
      ))}
    </>
  );
};

export default FilesSkeleton;
